import { useState, useEffect, useCallback } from 'react';

/**
 * Спільний стан шапки «Договори» (/contracts) — РЕДИЗАЙН.
 *
 * У топбар винесено пошук — єдиний операційний контрол сторінки (§6).
 * Фільтрація лишається клієнтською в тілі сторінки: сюди їде тільки рядок.
 *
 * Прийом той самий, що useAssetsUi / useSaleTermsUi / useUeexUi.
 */
const EV = 'helios:contracts-ui-change';

const state = { search: '' as string };

const emit = () => window.dispatchEvent(new CustomEvent(EV));

export function useContractsUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);

  const setSearch = useCallback((v: string) => { if (state.search !== v) { state.search = v; emit(); } }, []);

  return { search: state.search, setSearch };
}
